import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { mainAction } from "../../Redux/Actions";
import { Select, Space } from "antd";
import { GetCookieV2 } from "../../Utils";
const SelectServiceComp = React.forwardRef(({
  onSelected = () => { },
  onActive = 0,
}, ref) => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [valueS, setValueS] = useState(onActive);
  const dtLogin = GetCookieV2("All");
  const Customer = dtLogin?.Active;
  const onSelecteItem = (item) => {
    if (data.length > 0) {
      onSelected(data.find(p => p.value === item));
      setValueS(item);
    }
  };

  useEffect(() => {
    APIC_spServiceGetMany();
  }, []);

  useEffect(() => {
    if (onActive !== 0) {
      onSelecteItem(onActive);
    }
  }, [onActive]);

  const APIC_spServiceGetMany = async () => {
    let pr = {
      Json: JSON.stringify({
        Type: 0,
        CustomerId: Customer?.CustomerID,

      }),
      func: "APIC_spService_List",
    };
    const list = await mainAction.API_spCallServer(pr, dispatch);
    let dataOptions = [], IsActive = 0;
    dataOptions.push({ value: 0, label: "Chọn dịch vụ" });
    if (onActive === 0)
      setValueS(33);
    list.forEach((element, index) => {
      let option = { value: element.ServiceID, label: element.ServiceName, code: element.ServiceCode, isWeight: element.IsWeight, isMass: element.IsMass };
      dataOptions.push(option);
      if (element.ServiceID === onActive)
        IsActive = 1
    });
    setData(dataOptions);
    console.log("🚀 ~ constAPIC_spServiceGetMany= ~ dataOptions:", dataOptions)

    if (IsActive === 1) {
      setValueS(onActive);
    }
  };

  //return <Select value={valueS} onChange={onSelecteItem} options={data} ref={ref} />;
  return (
    <Select
      onChange={onSelecteItem}
      style={{
        width: "100%",
      }}
      placeholder="Chọn phường xã"
      value={valueS}
      options={data}
      optionRender={(option) => (
        <Space>
          <span role="img" aria-label={option.label}>
            {option.label}
          </span>
        </Space>
      )}
      ref={ref}
      showSearch
      filterOption={(input, option) =>
        option.label.toLowerCase().includes(input.toLowerCase())
      }
    />
  );
});

export const SelectService = React.memo(SelectServiceComp);
